import { sessionState } from 'src/app/core/services/signal-state.storage';
import { AfterViewInit, Component, DestroyRef, inject, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppService } from "../app.service";
import { mygarage } from "../shared/Models/Constants";

@Component({
    selector: "app-top-nav",
    templateUrl: "./top-nav.component.html",
    styleUrls: ["./top-nav.component.scss"],
    standalone: false
})
export class TopNavComponent implements OnInit, AfterViewInit {

  private readonly destroyRef = inject(DestroyRef);

  isAcura: boolean = false;
  myGarageHost = "https://mygarage.honda.com"

  constructor(private router: Router, private service: AppService) {
    let vehicleData = sessionState.getItem("vehicleMake");
    if (vehicleData) {
      if (vehicleData.toLowerCase() == 'acura') {
        this.isAcura = true;
      }
    }    
   }


  ngOnInit(): void {
    this.setIsAcuraLocally()
    this.myGarageHost = mygarage
  }


  onPressAcuraLink() {
    this.router.navigate(['/'])
    window.location.href = this.myGarageHost + '/s/acuralink-marketing';
    // this.router.navigate(["./acuraLink"]);
  }

  // incase of honda link calll this: 1934
  onPressHondaLink() {
    this.router.navigate(['/'])
    window.location.href = this.myGarageHost + '/s/hondalink-marketing';
  }

  onPressOwners() {
    this.router.navigate(['/'])
    window.location.href = this.myGarageHost + '/s/garage-honda';
    // this.router.navigate(["./owners"]);
  }
  onPressFaqs() {
    this.router.navigate(['/'])
    window.location.href = this.myGarageHost + '/s/article/HondaLink-Frequently-Asked-Questions-H?brand=HondaAutos';
    // this.router.navigate(["./faqs"]);
  }
  onPressmyAccount() {
    this.router.navigate(['/'])
    window.location.href = this.myGarageHost + '/s/';
    // this.router.navigate(["./myAccount"]);
  }
  onPressSignOut() {
    sessionState.clear()
    this.router.navigate(['/'])
    window.location.href = this.myGarageHost + '/s/';
  }
  ngAfterViewInit(): void {
    this.service.checkIsDataAvailable().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res) => {
      setTimeout(() => {
        if (res) {
          this.setIsAcuraLocally()
        } else {
          this.getVehicleDetails()
        }
      }, 1);
    });
  }
  setIsAcuraLocally() {
    let vehicleData = this.service.getVehicleData()
    if (vehicleData) {
      if (vehicleData.make.toLowerCase() == "acura") {
        this.isAcura = true
      }
    }
  }
  getVehicleDetails() {
    this.service.MyVehicle().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res) => {
      if (res && res.status == "SUCCESS") {
        let vehicleInfo = res.vehicleInfo
        if (vehicleInfo && vehicleInfo.length > 0) {
          let vehicleMake = vehicleInfo[0].DivisionName
          if (vehicleMake == 'Honda') {
            this.isAcura = false
          } else {
            this.isAcura = true
          }
        }
      }
    })
  }
}
